module.exports = __webpack_public_path__ + "img/20210118_162053.1bf09132.jpg";